import { provideComponent, useData } from 'scrivito'

import { DataGroupWidget } from './DataGroupWidgetClass'
import { EntityListContextProvider } from '../../Components/EntityListContext'

provideComponent(DataGroupWidget, ({ widget }) => {
  const id = ['DataGroupWidget', widget.id(), useData().dataItem()?.id()].join(
    '-',
  )

  return (
    <EntityListContextProvider key={id} content={widget} attribute="content" />
  )
})
